import { Suspense } from "react";
import Navigation from "./../components/Navigation";
import { Main, Header, Img, Rubrik1, Rubrik2 } from "../styles/AboutStyles";
import SEO from "./../components/SEO";

import vi from "./../images/vi_stor.jpg";
import rubrik1 from "./../images/rubrik_about1.png";
import rubrik2 from "./../images/rubrik_about2.png";

import HomeButton from "../components/HomeButton";
import { useContent } from "../i18n/useContent";

const Welcome = () => {
    const Content = useContent('welcome');

    return (
        <>
            <SEO pageKey="about" />
            <Navigation page={'welcome'} />
            <Main>
                <article>
                    <Header><h1 alt={"Välkommen till Oxelö Krog i Gamla Oxelösund!"}><Rubrik1 src={rubrik1} width='58%' /><Rubrik2 src={rubrik2} width='73%' width2='42%' /></h1> </Header>
                    <div>
                        <Img src={vi} />
                        <Suspense fallback={<div>...</div>}>
                            <Content />
                        </Suspense>
                        <HomeButton />
                    </div>
                </article>
            </Main>
        </>
    );
}

export default Welcome;
